import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {t} from 'shared/core';
import CustomFieldOption from './CustomFieldOption';
import {EmployeeGroup} from 'main/stores/employee_groups';
import _ from 'lodash';

class CustomField extends DomainObject {
  id;
  name;
  description;
  customFieldGroupId;
  fieldType = 'text_field';
  employeeCanEdit = false;
  displayOnHire = false;
  __employeeCanView = false;
  createdAt;
  availableInReports = false;
  displayInPayroll = false;
  required = false;
  order;
  options = [];

  _relations = {
    options: [CustomFieldOption],
    employeeGroup: EmployeeGroup
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      description: observable,
      customFieldGroupId: observable,
      fieldType: observable,
      employeeCanEdit: observable,
      displayOnHire: observable,
      __employeeCanView: observable,
      createdAt: observable,
      availableInReports: observable,
      displayInPayroll: observable,
      required: observable,
      order: observable,
      options: observable,
      employeeCanView: computed,
      sortedOptions: computed,
      formattedFieldType: computed
    });

    this.merge(other);
  }

  set employeeCanView(value) {
    this.__employeeCanView = value;

    if (!this.employeeCanView) {
      this.employeeCanEdit = false;
    }
  }

  get employeeCanView() {
    return this.__employeeCanView;
  }

  get sortedOptions() {
    return _.sortBy(this.options, 'id');
  }

  get formattedFieldType() {
    return t(`models.custom_field.field_type.${this.fieldType}`);
  }

  toJS() {
    return {
      ...super.toJS(),
      employeeCanView: this.employeeCanView
    };
  }
}

export default CustomField;
